import React from "react";

interface GomakeAiIconProps {
  width?: number | string;
  height?: number | string;
  style?: React.CSSProperties;
  className?: string;
}

const GomakeAiIcon: React.FC<GomakeAiIconProps> = ({
  width = 24,
  height = 24,
  style,
  className,
  ...props
}) => {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1000 1000"
      width={width}
      height={height}
      style={style}
      className={className}
      {...props}
    >
      <defs>
        <style>
          {`
            .cls-1 {
              fill: #fff;
            }
            .cls-2 {
              fill: #2e3092;
            }
            .cls-3 {
              fill: #8ba4cf;
            }
            .cls-4 {
              fill: #6b85c2;
            }
          `}
        </style>
      </defs>
      <rect
        className="cls-2"
        width="1000"
        height="1000"
        rx="129.03"
        ry="129.03"
      />
      <path
        className="cls-1"
        d="M704.98,531.84c21.38,0,40.49-5.23,57.32-15.69,16.83-10.92,30.02-25.48,39.58-43.67,9.55-18.65,14.1-39.58,13.65-62.78.45-23.66-4.09-44.58-13.65-62.78-9.55-18.65-22.75-33.21-39.58-43.67s-35.94-15.69-57.32-15.69-40.71,5.46-58,16.38c-16.83,10.46-30.02,25.02-39.58,43.67-9.55,18.2-14.1,38.9-13.65,62.1-.45,23.2,4.09,44.13,13.65,62.78,9.55,18.2,22.75,32.75,39.58,43.67,17.29,10.46,36.62,15.69,58,15.69ZM704.98,595.98c-35.03,0-66.42-7.96-94.17-23.88-27.29-16.38-48.9-38.44-64.82-66.19-15.92-28.2-23.88-60.28-23.88-96.21s7.96-67.78,23.88-95.53c15.92-28.2,37.53-50.27,64.82-66.19,27.75-16.38,59.14-24.57,94.17-24.57s65.51,8.19,92.8,24.57c27.75,15.92,49.59,37.99,65.51,66.19,15.92,27.75,23.88,59.59,23.88,95.53s-7.96,68.01-23.88,96.21c-15.92,27.75-37.76,49.81-65.51,66.19-27.29,15.92-58.23,23.88-92.8,23.88ZM301.72,595.98c-26.36,0-50.99-4.68-73.89-14.05-22.9-9.71-43.02-23.07-60.36-40.07-17.35-17-30.87-36.77-40.59-59.32-9.37-22.9-14.05-47.53-14.05-73.89s4.68-50.3,14.05-72.85c9.71-22.55,23.07-42.15,40.07-58.8,17.35-17,37.47-30.18,60.36-39.55,22.9-9.37,47.53-14.05,73.89-14.05,18.39,0,36.25,2.6,53.6,7.81,17.69,5.2,33.65,12.49,47.87,21.85,14.22,9.37,25.84,20.12,34.86,32.26l-36.42,37.99c-10.41-10.06-21.16-18.39-32.26-24.98-10.75-6.59-21.85-11.62-33.3-15.09-11.45-3.47-22.9-5.2-34.34-5.2-18.73,0-36.08,3.3-52.04,9.89-15.61,6.59-29.49,15.78-41.63,27.58-11.79,11.79-20.99,25.67-27.58,41.63-6.59,15.61-9.89,32.78-9.89,51.51s3.47,35.21,10.41,51.51c6.94,15.96,16.48,30.01,28.62,42.15,12.49,12.14,26.71,21.68,42.67,28.62,16.3,6.94,33.48,10.41,51.51,10.41,13.53,0,26.36-1.91,38.51-5.72,12.14-4.16,22.9-9.89,32.26-17.17,9.37-7.28,16.65-15.61,21.85-24.98,5.2-9.71,7.81-19.95,7.81-30.7v-10.41l7.81,7.28h-111.36v-55.68h161.31c.69,3.82,1.21,7.63,1.56,11.45.35,3.47.52,6.94.52,10.41.35,3.12.52,6.24.52,9.37,0,23.94-4.16,45.79-12.49,65.56-8.33,19.43-19.95,36.25-34.86,50.47-14.57,14.22-31.74,25.32-51.51,33.3-19.43,7.63-40.59,11.45-63.48,11.45Z"
      />
      <g>
        <path
          className="cls-4"
          d="M656.32,803.46c4.45,0,8.06-13.13,8.06-29.33s-3.61-29.33-8.06-29.33c0,0,0,0,0,0h-305.05c-4.45,0-8.06,13.13-8.06,29.33s3.61,29.33,8.06,29.33h305.05s0,0,0,0Z"
        />
        <path
          className="cls-3"
          d="M664.38,774.14c0-16.2-3.61-29.33-8.06-29.33s-8.06,13.13-8.06,29.33,3.61,29.33,8.06,29.33,8.06-13.13,8.06-29.33Z"
        />
      </g>
      <rect
        className="cls-1"
        x="422.03"
        y="720.43"
        width="147.66"
        height="130.96"
        rx="17.08"
        ry="17.08"
      />
      <g>
        <path
          className="cls-4"
          d="M656.32,734.26c4.45,0,8.06-13.13,8.06-29.33s-3.61-29.33-8.06-29.33c0,0,0,0,0,0h-305.05c-4.45,0-8.06,13.13-8.06,29.33s3.61,29.33,8.06,29.33h305.05s0,0,0,0Z"
        />
        <path
          className="cls-3"
          d="M664.38,704.93c0-16.2-3.61-29.33-8.06-29.33s-8.06,13.13-8.06,29.33,3.61,29.33,8.06,29.33,8.06-13.13,8.06-29.33Z"
        />
      </g>
    </svg>
  );
};

export { GomakeAiIcon };
